
import { NormalizedAnnotation, OptGroup, Option } from '@/types/apptypes';
import { CqlAttributeData, CqlQueryBuilderOptions } from '@/components/cql/cql-types';
import SelectPicker from '@/components/SelectPicker.vue';
import Modal from '@/components/Modal.vue';
import CqlAddAttributeButton from '@/components/cql/CqlAddAttributeButton.vue';
import Autocomplete from '@/components/Autocomplete.vue';
import { blacklabPaths } from '@/api';

import useModel from './useModel';
import { escapeRegex } from '@/utils';


export default useModel<CqlAttributeData>().extend({
	components: {
		CqlAddAttributeButton,
		SelectPicker,
		Modal,
		Autocomplete,
	},
	props: {
		options: { type: Object as () => CqlQueryBuilderOptions, required: true },
	},
	data: () => ({ showModal: false }),
	computed: {
		textDirection(): 'ltr' | 'rtl' { return this.options.textDirection; },
		currentAnnotation(): NormalizedAnnotation | undefined {
			return this.options.allAnnotationsMap[this.model.annotationId];
		},
		autocompleteUrl(): string {
			if (!this.currentAnnotation) return '';
			return blacklabPaths.autocompleteAnnotation(INDEX_ID, this.currentAnnotation.annotatedFieldId, this.currentAnnotation.id);
		},

		hasUploadedValue(): boolean { return !!this.model.uploadedValue },

		uploadedValuesSummary(): string {
			if (!this.hasUploadedValue) return '';
			return `${this.model.values.length} value${this.model.values.length !== 1 ? 's' : ''}`;
		},

		textValue: {
			get(): string {
				return this.model.values.join('|');
			},
			set(value: string) {
				this.model.values = value ? [value] : [''];
			}
		}
	},
	methods: {
		escapeRegex,
		handleTextInput(event: Event) {
			const target = event.target as HTMLInputElement;
			this.model.values = target.value ? [target.value] : [''];
		},

		parseUploadedFile(contents: string): string[] {
			return contents.trim().split(/\s+/g).map(v => v.trim()).filter(line => line);
		},

		handleFileUpload(event: Event) {
			const target = event.target as HTMLInputElement;
			const file = target.files?.[0];
			if (!file) return;

			const reader = new FileReader();
			reader.onload = (e) => {
				const content = e.target?.result as string;
				if (content) {
					// Split by lines and filter out empty lines
					this.model.uploadedValue = content;
					this.model.values = this.parseUploadedFile(content);
				}
			};
			reader.readAsText(file);
		},

		confirmModalEditor() {
			this.model.values = this.parseUploadedFile(this.model.uploadedValue!);
			this.closeModalEditor();
		},
		clearModalEditor() {
			this.model.uploadedValue = undefined;
			this.model.values = [''];
			this.closeModalEditor();
		},
		openModalEditor() { this.showModal = true; },
		closeModalEditor() { this.showModal = false; },

		emitAddAttributeGroup(operator: string) {
			this.$emit('add-attribute-group', operator);
		}
	}
});
